import { useEffect, useState } from 'react';
import { useCurrentUserStore } from 'store/UserStore';
import { Permission } from 'interfaces';
import { useIsAdmin } from 'hooks/useIsAdmin';

interface CanCreateReturn {
  canCreate: boolean;
}

export const useCanCreate = (path: string): CanCreateReturn => {
  const { role } = useCurrentUserStore();
  const isAdmin = useIsAdmin();
  const [canCreate, setCanCreate] = useState<boolean>(false);

  useEffect(() => {
    if (isAdmin) {
      setCanCreate(true);
    } else {
      const hasCreatePermission =
        role?.permissions?.some(
          (permission: Permission) =>
            permission.resource === path && permission.action === 'create'
        ) ?? false;
      setCanCreate(hasCreatePermission);
    }
  }, [isAdmin, path, role]);

  return { canCreate };
};
